import { styled } from '@mui/system';
import { Button } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export const ArrowIcon = styled(ChevronRightIcon)(() => ({
  marginRight: '-10px'
}));

export const ArrowIconButton = styled(Button)(() => ({
  color: 'white',
  width: '24px',
  minWidth: '24px',
  boxShadow: 'none',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: '16px',
  borderRadius: '8px'
}));
